import React, { ComponentPropsWithoutRef } from 'react'
import { getCategoriesData } from '~shared/api/categories/getCategories'
import { getPopularPrograms } from '~shared/api/programs-popular/getPopularPrograms'
import { Button } from '~shared/components/button-v2'
import { CarouselPrograms } from '~shared/components/carousel-programs'
import { cn } from '~shared/utils/cn'

interface PopularProgramsSectionProps
  extends ComponentPropsWithoutRef<'section'> {
  popularPrograms: Awaited<ReturnType<typeof getPopularPrograms>>
}

export const PopularProgramsSection: React.FC<
  PopularProgramsSectionProps
> = props => {
  const { className = '', popularPrograms } = props
  const [tabSelected, setTabSelected] = React.useState(
    'bakalavriat magistratura college kursy mba'
  )

  const tabs = [
    {
      id: 1,
      label: 'часто выбирают',
      slug: 'bakalavriat magistratura college kursy mba'
    },
    { id: 2, label: 'высшее образование', slug: 'bakalavriat magistratura' },
    { id: 3, label: 'курсы', slug: 'kursy' },
    { id: 4, label: 'MBA', slug: 'mba' },
    { id: 5, label: 'колледж', slug: 'college' }
  ]

  return (
    <section className={cn(className, '')}>
      <div className={cn('container container-slim')}>
        <h2 className='typo-section-heading typo-section-heading-mb'>
          Популярные программы
        </h2>
        <div className='overflow-x-auto w-full mb-[20px] no-scrollbar'>
          <div className='flex md:grid grid-cols-5 gap-[8px] lg:gap-[16px] pb-[1px] md:min-w-[1067px] lg:min-w-[930px] min-w-[650px]'>
            {tabs.map(el => (
              <Button
                key={el.id}
                variant='none'
                className={cn(
                  'h-[50px] md:h-[67px] rounded-[16px] md:rounded-[24px] px-[16px] lg:px-0',
                  tabSelected === el.slug
                    ? 'bg-accent text-primary'
                    : 'bg-secondary text-tertiary'
                )}
                onClick={() => setTabSelected(el.slug)}>
                {el.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
      <CarouselPrograms
        popularPrograms={
          popularPrograms?.filter(el =>
            tabSelected.includes(el.category?.slug ?? '')
          ) ?? null
        }
      />
    </section>
  )
}
